'use client';
import React, { useEffect } from 'react';
import { AppInsightsProvider } from '@/app/AppInsightsProvider';
import { TRPCProvider } from '@/trpc/client';

export default function Providers({
  children,
  appInsightsConnectionString,
}: {
  children: React.ReactNode;
  appInsightsConnectionString?: string;
}) {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      Object.assign(window.document, {
        version: {
          package: process.env.NEXT_PUBLIC_PACKAGE_VERSION,
          release: process.env.NEXT_PUBLIC_RELEASE_ID,
        },
      });
    }
  }, []);
  return (
    <TRPCProvider>
      <AppInsightsProvider appInsightsConnectionString={appInsightsConnectionString}>
        {children}
      </AppInsightsProvider>
    </TRPCProvider>
  );
}
